// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3O8Up","productName":"Table_productName__2YtiO"};